import type { TranslationInterface } from '.';

export const TurkishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Bir mesaj yazın...',
  your_issue_has_been_resolved: 'Sorununuz çözüldü!',
  new_conversation: 'Yeni konuşma',
  welcome_screen_title: 'Destek sohbetimize hoş geldiniz',
  welcome_screen_description:
    'Yardım etmek için buradayız! Bir konuşma başlatın, en kısa sürede size geri döneceğiz.',
  your_name_placeholder: 'Adınız',
  your_email_placeholder: 'E-posta adresiniz',
  start_chat_button: 'Destekle konuş',
  start_chat_button_loading: 'Bağlanıyor...',
  i_need_more_help: 'Daha fazla yardıma ihtiyacım var',
  this_was_helpful: 'Bu yardımcı oldu',
  optional: 'İsteğe bağlı',
  no_conversations_yet: 'Henüz konuşma yok',
  back_to_conversations: 'Konuşmalara geri dön',
  closed_conversations: 'Kapatılan konuşmalar',
  csat_title: 'Görüşmeniz nasıldı?',
  csat_submitted_title: 'Görüşmeyi şöyle değerlendirdiniz',
  csat_feedback_placeholder: 'Bize daha fazlasını anlatın... (isteğe bağlı)',
  follow_up_placeholder: 'Devam et…',
  companion_layout_label: 'Düzen',
  companion_layout_floating: 'Kayan',
  companion_layout_sidebar: 'Kenar çubuğu',
  companion_layout_fullscreen: 'Tam ekran',
  companion_close: 'Kapat',
  companion_history: 'Konuşma geçmişi',
  companion_expand_chat: 'Sohbeti genişlet',
  companion_sidebar_dock_label: 'Sabitleme',
  companion_sidebar_side_label: 'Taraf',
  companion_sidebar_left: 'Sol',
  companion_sidebar_right: 'Sağ',
  companion_resize_chat: 'Sohbeti yeniden boyutlandır',
  scroll_to_bottom: 'En alta kaydır',
  thinking: 'Düşünüyor…',
  running: 'Çalışıyor…',
  steps: 'adım',
  step_arguments: 'Bağımsız değişkenler',
  step_result: 'Sonuç',
  attach_files:
    'Görsel, video, PDF veya elektronik tablo ekle (en fazla 25 MB)',
  mark_page_active:
    "İşaretlemek için sayfadaki bir öğeye tıklayın — iptal etmek için Esc'ye basın",
  mark_page: 'Hakkında soru sormak için sayfadaki bir öğeyi işaretleyin',
  stop_response: 'Yanıtı durdur',
  copy_reply: 'Yanıtı kopyala',
  mentions_empty: 'Eşleşme yok',
  copied: 'Kopyalandı',
  send_message: 'Mesaj gönder',
  upload_failed: 'Yükleme başarısız: {error}',
  remove_attachment: 'Eki kaldır',
  json_no_items: 'Öğe yok',
  json_no_data: 'Veri yok',
  json_no_chart_data: 'Grafik için veri yok',
  json_unsupported: 'Desteklenmiyor: {type}',
  json_see_less: 'Daha az göster',
  json_phone_agent: 'Telefon temsilcisi',
  json_phone_agent_test: 'Web üzerinden test et',
  page_context_remove: 'Sayfa bağlamını kaldır',
  json_see_more: '{count} tane daha göster',
  queued_label: '{count} Sırada',
  remove_queued_message: 'Mesajı sıradan kaldır',
  send_queued_now: 'Sıradaki mesajları şimdi gönder',
  turn_failed_message: 'Bir sorun oluştu ve yanıt ulaşmadı.',
  turn_failed_retry: 'Tekrar dene',
  page_mark_hint: 'İşaretlemek için bir öğeye tıklayın',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Kutu',
  page_mark_shape_circle: 'Daire',
  page_mark_shape_arrow: 'Ok',
  page_mark_shape_bracket: 'Ayraç',
  page_mark_shape_underline: 'Alt çizgi',
  page_mark_shape_highlight: 'Vurgu',
  page_mark_shape_strike_through: 'Üstü çizili',
  page_mark_shape_crossed_off: 'Çarpı at',
  page_mark_shape_aria: 'İşaret şekli: {shape}',
  page_mark_note_placeholder: "Not ekleyin… (Eklemek için Enter'a basın)",
  page_mark_attach: 'İşareti ekle',
  page_mark_remove: '{label} öğesini kaldır',
  page_mark_region: 'İşaretli bölge',
  page_mark_default_message: 'Bu nedir?',
  file_rejected: 'Dosya türü desteklenmiyor veya dosya çok büyük.',
  dictate: 'Dikte et',
  stop_dictation: 'Dikteyi durdur',
  dictation_mic_blocked: 'Dikte etmek için mikrofon erişimine izin verin',
  dictation_unavailable: 'Dikte şu anda kullanılamıyor',
  questions_back: 'Geri',
  questions_next: 'İleri',
  questions_send: 'Gönder',
  questions_type_answer: 'Kendim yazayım',
  questions_answer_placeholder: 'Yanıtınızı yazın…',
  close_conversation_title: 'Görüşmeyi kapat',
  close_conversation_description:
    'Bu görüşmeyi kapatmak istediğinizden emin misiniz?',
  close_conversation_cancel: 'Hayır',
  close_conversation_confirm: 'Evet',
  dialog_close: 'Kapat',
  zoom_in: 'Yakınlaştır',
  zoom_out: 'Uzaklaştır',
  reset_zoom: 'Yakınlaştırmayı sıfırla',
  support_chat_aria_label: 'Destek sohbeti',
};
